import { Expose } from "class-transformer";

export class AiChatbotChunkEntity {
  @Expose()
  get isFirstChunk(): boolean {
    const firstIndex = 0;
    const isFirstChunk = this.sequenceNumber === firstIndex;
    return isFirstChunk;
  }

  @Expose()
  sequenceNumber!: number;

  @Expose()
  payload!: string;

  @Expose()
  messageId!: number;
}
